import { styled } from "@mui/material/styles";

export const Spacer = styled("div")`
  flex: 1 1 100%;
`;
